'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-console */
var EVENT = 'event';
var TRAITS = 'traits';
var OPTIONS = 'options';

var previousEvents = {};

var DEFAULT_SETTINGS = exports.DEFAULT_SETTINGS = {
    alias: true,
    group: true,
    identify: true,
    track: true,
    page: true
};

function logHandler(event, properties, options) {
    console.group(EVENT, event);
    console.log(TRAITS, properties);
    console.log(OPTIONS, options);
    console.groupEnd(EVENT);
}

function enableLogging() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SETTINGS;

    Object.keys(previousEvents).forEach(function (event) {
        if (previousEvents[event]) {
            global.analytics.off(event, logHandler);
        }
    });
    Object.keys(events).forEach(function (event) {
        if (events[event]) {
            global.analytics.on(event, logHandler);
        }
    });
    Object.assign(previousEvents, events);
}

exports.default = enableLogging;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/utils/enableLogging.js
// module id = 2261
// module chunks = 0